var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSnowy(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 54h47a16 16 0 0 0 0-32 24 24 0 0 0-45-7A20 20 0 0 0 24 54z",
    fill: "#dce8f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 54h47a16 16 0 0 0 0-32 24 24 0 0 0-45-7A20 20 0 0 0 24 54z",
    fill: "none",
    stroke: "#9db5c7",
    strokeWidth: 5,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    stroke: "#72a9c9",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31 67v14M24 74h14M26 69l10 10M36 69L26 79"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 67v14M51 74h14M53 69l10 10M63 69L53 79"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowy);
export default __webpack_public_path__ + "static/media/snowy.3ef99d65474b71a18cef8a2a680ff8a5.svg";
export { ForwardRef as ReactComponent };